import HeatmapComponent from "../insight/heatMap";
import React, { useEffect, useRef, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { processSurveyAnswers } from "../insight/index";
const HeatMap = () => {
  const themeMode = useSelector((state) => state.themeMode);
  const chartRef = useRef(null);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const leftMenuVisibility = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.leftMenuVisibility;
  const currentSurveyInsightData = useMemo(() => {
    const activeTab = topMenuTabs.tabs.find(
      (tab) => tab.id === topMenuTabs.activeTab
    );
    return activeTab ? activeTab.states.currentSurveyInsightData : null;
  }, [topMenuTabs.tabs, topMenuTabs.activeTab]);
  const [totalAnswers, setTotalAnswers] = useState([]);
  useEffect(() => {
    const survey_answers =
      currentSurveyInsightData?.report_detail?.survey_answers;
    if (survey_answers) {
      const processedAnswers = processSurveyAnswers(survey_answers);
      if (JSON.stringify(processedAnswers) !== JSON.stringify(totalAnswers)) {
        setTotalAnswers(processedAnswers);
        console.log("Processed Answers:", processedAnswers);
      }
      // setTotalAnswers(processedAnswers);

      console.log("Processed Answers:", processedAnswers);
    }
  }, [currentSurveyInsightData]);
  return (
    <div
      className={`flex flex-col w-full pl-4 ${
        themeMode === "dark"
          ? "bg-[#1a1a28] text-white"
          : "bg-[#fbfbfc] text-black"
      }`}
    >
      {totalAnswers.length > 0 && (
        <div className={`flex flex-0 w-auto 2xl:flex-1  w-auto `}>
          <HeatmapComponent totalData={totalAnswers} themeMode={themeMode} />
        </div>
      )}
    </div>
  );
};
export default HeatMap;
